module.exports = __webpack_public_path__ + "assets/img/returnBtn-ac62d45f.png";